export default "__VITE_ASSET__Ct_MR$OG__"